module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-points-record",
    class: {
      'is-expanded': _vm.showNotes
    }
  }, [_c('div', {
    staticClass: "c-points-record__overview"
  }, [_c('div', {
    staticClass: "c-points-record__overview__numbers"
  }, [_c('h5', {
    staticClass: "c-points-record__overview__numbers__date u-number-font"
  }, [_vm._v("\n        " + _vm._s(_vm.pointsRecord.created_at) + "\n      ")]), _vm._v(" "), _c('h6', {
    staticClass: "c-points-record__overview__numbers__points u-number-font"
  }, [(_vm.pointsRecord.points > 0) ? _c('span', {
    staticClass: "t-positive"
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), (_vm.pointsRecord.points < 0) ? _c('span', {
    staticClass: "t-negative"
  }, [_vm._v("-")]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.formatNumber(Math.abs(_vm.pointsRecord.points))) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-points-record__overview__headline"
  }, [_c('h4', {
    staticClass: "c-points-record__overview__headline__program"
  }, [(_vm.pointsRecord.source === 'redemption') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.$t('web.points_record.order_number', {
    order_number: _vm.pointsRecord.order_number
  })) + "\n        ")]) : (_vm.pointsRecord.source === 'refund') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.$t('web.points_record.refund_label')) + "\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.pointsRecord.program_name) + "\n        ")])]), _vm._v(" "), _c('h5', {
    staticClass: "c-points-record__overview__headline__rule"
  }, [_vm._v("\n        " + _vm._s(!_vm.pointsRecord.order_number ? _vm.pointsRecord.description : '') + "\n      ")]), _vm._v(" "), (_vm.pointsRecord.source === 'refund') ? _c('div', {
    staticClass: "c-points-record__overview__maths"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.points_record.refund_details', {
    order_number: _vm.pointsRecord.order_number,
    order_notes: _vm.pointsRecord.order_notes
  })) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "c-points-record__notes"
  }, [(_vm.pointsRecord.notes && _vm.showNotes) ? _c('div', {
    staticClass: "c-points-record__notes__text"
  }, [_c('h5', {
    staticClass: "c-points-record__notes__text__headline"
  }, [_vm._v(_vm._s(_vm.$t('web.points_record.notes_label')))]), _vm._v(" "), _c('p', {
    staticClass: "u-small-paragraph"
  }, [_vm._v(_vm._s(_vm.pointsRecord.notes))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-points-record__notes__actions"
  }, [(_vm.pointsRecord.notes) ? _c('button', {
    staticClass: "c-points-record__notes__actions__link t-button-borderless",
    on: {
      "click": _vm.toggleNotes
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.points_record.notes_toggle')) + "\n        "), _c('span', {
    staticClass: "c-points-record__notes__actions__link__icongroup"
  }, [(!_vm.showNotes) ? _c('i', {
    staticClass: "fa fa-chevron-down is-collapsed"
  }) : _vm._e(), _vm._v(" "), (_vm.showNotes) ? _c('i', {
    staticClass: "fa fa-chevron-up is-expanded"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.pointsRecord.order_number) ? _c('a', {
    staticClass: "c-points-record__notes__actions__link t-button-borderless",
    on: {
      "click": function($event) {
        return _vm.goToPage('MyOrders')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.points_record.orders_link')) + "\n        "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac751826"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/PointsRecord.vue
// module id = 562
// module chunks = 1